import React, { SyntheticEvent } from 'react';
import styled from 'styled-components';
import { useSearchFilter, SearchFilterProps } from './hooks/useSearchFilter';

// Types
import { QaTestId } from 'src/types';

export interface SearchBoxProps extends SearchFilterProps {
  inputPlaceholder?: string;
  style?: object;
  className?: string;
  hideIcon: boolean;
  onKeyUp?: React.EventHandler<SyntheticEvent>;
}

export const SearchBox = ({
  onFilterUpdate,
  onKeyUp,
  onApplyFilter,
  value,
  inputPlaceholder,
  minLength = 2,
  delay = 300,
  style = {},
  className = '',
  hideIcon = false,
  testId,
}: SearchBoxProps & QaTestId) => {
  const { searchFilter, applyFilter } = useSearchFilter({
    value,
    delay,
    minLength,
    onFilterUpdate,
    onApplyFilter,
  });

  return (
    <SearchBoxContainer
      data-test-id={testId}
      className={`${className}`}
      style={style}
    >
      <input
        data-test-id={`${testId}-input`}
        value={searchFilter}
        placeholder={inputPlaceholder ?? 'Search'}
        onChange={(e) => applyFilter(e.target.value)}
        onKeyUp={onKeyUp}
      />
      {!hideIcon && <i className="fa fa-search" />}
    </SearchBoxContainer>
  );
};

const SearchBoxContainer = styled.div`
  position: relative;

  i {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(10px, -50%);
    color: ${({ theme }) => theme.colors.grey60};
  }

  input {
    border-radius: 3px;
    border: 1px solid ${({ theme }) => theme.colors.textLightGray};
    display: block;
    font-size: 1.5rem;
    font-weight: 300;
    outline: 0;
    padding: 0.8rem 0.8rem 0.8rem 3.5rem;
    transition: box-shadow 0.3s ease, border-color 0.3s ease;
    width: 100%;
  }
`;
